import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ROLES } from 'shared-package';
import { ExerciseVM } from '../models/exercise-vm';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {
  E2eDirective,
  EQUIPMENT_LABELS,
  EXERCISE_TYPE_LABELS,
  MUSCLE_LABELS,
} from '@fitness-tracker/shared/utils';

@Component({
  selector: 'components-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatCardModule,
    E2eDirective,
    MatButtonModule,
    MatIconModule,
    TitleCasePipe
],
})
export class ExerciseComponent {
  @Input()
  public exercise!: ExerciseVM;
  @Input()
  public idx!: number;

  @Output()
  public readonly exerciseEdited = new EventEmitter<string>();
  @Output()
  public readonly exerciseViewed = new EventEmitter<string>();
  @Output()
  public readonly exerciseDeleted = new EventEmitter<string>();
  @Output()
  public readonly exerciseAddedToWorkout = new EventEmitter<string>();

  protected readonly roles = ROLES;
  protected readonly muscleLabels = MUSCLE_LABELS;
  protected readonly equipmentLabels = EQUIPMENT_LABELS;
  protected readonly exerciseTypeLabels = EXERCISE_TYPE_LABELS;

  public viewExercise({ id }: ExerciseVM): void {
    this.exerciseViewed.emit(id);
  }

  public editExercise({ id }: ExerciseVM): void {
    this.exerciseEdited.emit(id);
  }

  public deleteExercise({ id }: ExerciseVM): void {
    this.exerciseDeleted.emit(id);
  }

  public addedToWorkout({ id }: ExerciseVM): void {
    this.exerciseAddedToWorkout.emit(id);
  }

  protected muscleLabelsFor(targetMuscles: string[]): string {
    return targetMuscles.map((muscle) => this.muscleLabels[muscle]).join(', ');
  }
}
